module.exports = __webpack_public_path__ + "static/media/market-makers-logo.64dd5cae.png";